// @flow
import * as React from 'react';
import ChannelsDashboard from 'containers/channels/Channels';

export default class ReviewChannels extends React.PureComponent<*> {
  render() {
    return <ChannelsDashboard ugctype="Review" {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/reviews/ReviewChannels.js